import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
// import tieLogo from "../../assets/tieLogo.png";
import techinLogo from "../../assets/new-logo.jpg";
import { Link } from "react-router-dom";
import { useStyles } from "./dashMenuStyle";

export default function DashMenu() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar
        // className={classes.appBar}
        position="static"
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>

          <img
            className={classes.logo}
            // src={tieLogo}
            src={techinLogo}
            alt={"Tie"}
            height="3%"
            width="6%"
          />

          <Link to="/">
            <Typography className={classes.title} variant="h6" noWrap>
              ቴክ ኢን አይን
            </Typography>
          </Link>

          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
